// extracted by mini-css-extract-plugin
module.exports = {"modal":"PeripheralReturnModal_modal__25Sm4","inputNumber":"PeripheralReturnModal_inputNumber___6UzW"};